import instance from 'shared/helpers/axios';
import { catchError } from 'shared/helpers/catchError';
import {
  IFetchGtIdsDTO,
  IGetGtIds,
  IFetchSccpProvidersDTO,
  IFetchCountriesLvl2DTO,
  IFetchCountriesLvl2Params,
  ICampaignActionsDTO,
  TCampaignActionsParams,
} from './types';
import { GT_IDS_URL, DICTIONARIES_URL, SCCP_PROVIDERS_URL, TESTS_URL } from './constants';

export const fetchGtIds = async (params: IGetGtIds) => {
  try {
    const response = await instance.get<IFetchGtIdsDTO>(
      `${DICTIONARIES_URL}${GT_IDS_URL}`,
      {
        params,
      },
    );

    const { data } = response && response.data;
    const { items } = data;

    return items;
  } catch (error) {
    catchError(error);
  }
};

export const fetchSccpProviders = async () => {
  try {
    const response = await instance.get<IFetchSccpProvidersDTO>(
      `${DICTIONARIES_URL}${SCCP_PROVIDERS_URL}`,
    );

    const { data } = response && response.data;
    const { items } = data;

    return items;
  } catch (error) {
    catchError(error);
  }
};

export const fetchCountriesDataLvl2 = async (
  extId: number,
  params: IFetchCountriesLvl2Params,
) => {
  try {
    const response = await instance.get<IFetchCountriesLvl2DTO>(
      `${TESTS_URL}/${extId}/countries`,
      { params },
    );

    const { data } = response && response.data;
    return data;
  } catch (error) {
    catchError(error);
  }
};

export const campaignActionRequest = async (
  extId: number,
  type: TCampaignActionsParams,
) => {
  try {
    const response = await instance.post<ICampaignActionsDTO>(
      `${TESTS_URL}/${extId}/${type}`,
      {},
    );

    const { data } = response && response.data;
    return data;
  } catch (error) {
    catchError(error);
  }
};
